export default "__VITE_ASSET__W_bzu1Ft__"